export default "__VITE_ASSET__DlPHCbrX__"